var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C9.37665 2.25 7.25 4.37665 7.25 7C7.25 9.62335 9.37665 11.75 12 11.75C14.6234 11.75 16.75 9.62335 16.75 7C16.75 4.37665 14.6234 2.25 12 2.25Z",
    fill: "var(--ncap-500)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25C9.72474 14.25 7.63146 14.5946 6.0798 15.1764C5.30674 15.4663 4.62904 15.8296 4.13112 16.2711C3.63408 16.7117 3.25 17.2943 3.25 18C3.25 18.7057 3.63408 19.2883 4.13112 19.7289C4.62904 20.1704 5.30674 20.5337 6.0798 20.8236C7.63146 21.4054 9.72474 21.75 12 21.75C14.2753 21.75 16.3685 21.4054 17.9202 20.8236C18.6933 20.5337 19.371 20.1704 19.8689 19.7289C20.3659 19.2883 20.75 18.7057 20.75 18C20.75 17.2943 20.3659 16.7117 19.8689 16.2711C19.371 15.8296 18.6933 15.4663 17.9202 15.1764C16.3685 14.5946 14.2753 14.25 12 14.25Z",
    fill: "var(--ncap-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.244e4ed73e7ca50df1cfdd3fe73cd44c.svg";
export { ForwardRef as ReactComponent };